import { ModuleWithProviders } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "src/app/core/home/home.component";
import { AppConstants } from "./shared/constants/app.contants";
import { NavBarComponent } from "./core/nav-bar/nav-bar.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { VendorApplicationComponent } from "./core/vendor-application/vendor-application.component";
import { BankAccountComponent } from "./core/bank-account/bank-account.component";
import { ProfileComponent } from "./core/profile/profile.component";
import { MessageComponent } from "./core/message/message.component";
import { EmailTemplatesComponent } from "./core/email-templates/email-templates.component";
import { ManageVendorsComponent } from "./core/manage-vendors/manage-vendors.component";
import { ExecuteQueryComponent } from "./core/execute-query/execute-query.component";
import { FAQsComponent } from "./core/faqs/faqs.component";

const routerOptions: ExtraOptions = {
    scrollPositionRestoration: "enabled",
    anchorScrolling: "enabled",
    scrollOffset: [0, 64]
};

export const routes: Routes = [
    {
        path: '',
        component: NavBarComponent,
        canActivate: [AuthGuard], // Protect the route with the guard
        children: [
            {
                path: AppConstants.ROUTES.HOME,
                component: HomeComponent,
                pathMatch: 'full',
            },
            {
                path: 'manage-vendors',
                component: ManageVendorsComponent,
                pathMatch: 'full',
            },
            {
                path: 'execute-query',
                component: ExecuteQueryComponent,
                pathMatch: 'full',
            },
            {
                path: AppConstants.ROUTES.VendorApplication,
                component: VendorApplicationComponent,
                pathMatch: 'full',
            },
            {
                path: AppConstants.ROUTES.BankAccount,
                component: BankAccountComponent,
                pathMatch: 'full',
            },
            {
                path: AppConstants.ROUTES.email,
                component: EmailTemplatesComponent,
                pathMatch: 'full',
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: AppConstants.ROUTES.HOME
            },
            {
                path: AppConstants.ROUTES.Profile,
                component: ProfileComponent,
                pathMatch: 'full',
            },
            {
                path: AppConstants.ROUTES.Messages,
                component: MessageComponent,
                pathMatch: 'full',
            },
            {
                path: AppConstants.ROUTES.FAQs,
                component: FAQsComponent,
                pathMatch: 'full',
            },
            {
                path: AppConstants.ROUTES.TENDER,
                loadChildren: () => import('./modules/tender/tender.module').then((mod) => mod.TenderModule)
            },
            {
                path: AppConstants.ROUTES.BID,
                loadChildren: () => import('./modules/modules/bid/bid.module').then(m => m.BidsModule)
            },
            {
                path: AppConstants.ROUTES.FINANCIALS,
                loadChildren: () => import('./modules/modules/financials/financials.module').then(m => m.FinancialsModule)
            },
            {
                path: AppConstants.ROUTES.RFP_RFQ,
                loadChildren: () => import('./modules/modules/financials/financials.module').then(m => m.FinancialsModule),
                // TODO: Replace with RFP/RFQ module when created
                // loadChildren: () => import('./modules/modules/rfp-rfq/rfp-rfq.module').then(m => m.RfpRfqModule)
            }
        ]
    },

    {
        path: AppConstants.ROUTES.AUTHENTICATION,
        loadChildren: () => import('./modules/authentication/authentication.module').then(m => m.AuthenticationModule)
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: AppConstants.ROUTES.SERVICE_INTRODUCTION + "/" + AppConstants.ROUTES.MAIN
    }
]

export const APP_ROUTES: ModuleWithProviders<any> = RouterModule.forRoot(routes, routerOptions);
